@if (pageReady) {
  <main class="gs-page">
    <div class="gs-page-inner">
      <app-page-header [headerData]="headerData"></app-page-header>
      <div class="notification-container">
        <app-notification></app-notification>
      </div>
      <div class="gs-content-container">
        <div class="plan-details-container">
          <div class="current-plan-container">
            <h3 [innerHTML]="pageLabels.currentPlanTitleText" class="current-plan-title-text"></h3>
            <div class="current-plan">
              <mat-card class="current-plan-card">
                <mat-card-header class="plan-mat-card-header">
                  <p [innerHTML]="pageData.fullAddress" class="service-address"></p>
                </mat-card-header>
                <mat-card-content class="current-plan-card-content">
                  <div class="plan-container">
                    @if (pageData.plan.planType.includes("OnePrice Plan")) {
                      <div class="opp-plan-container">
                        <h3 [innerHTML]="pageData.plan.planType" class="h3 plan-type"></h3>
                        <p class="customer-preferred-text" [innerHTML]="pageLabels.customerPreferredText"></p>
                      </div>
                    } @else {
                      <h3 [innerHTML]="pageData.plan.planType" class="h3 plan-type"></h3>
                    }
                    <div class="rate-details">
                      @if (showExpirationDate) {
                        @if (pageData.plan.planType.includes("OnePrice Plan")) {
                          <div class="one-side-details">
                            <p [innerHTML]="pageLabels.expirationText" class="detail-title"></p>
                            <p [innerHTML]="pageData.expirationDate" class="detail-value-opp"></p>
                          </div>
                          <mat-divider class="divider"></mat-divider>
                          <div class="one-side-details">
                            <p [innerHTML]="pageLabels.planDetailsText" class="detail-title"></p>
                            <div class="one-price-plan-tooltip-container">
                              <p class="detail-value" [innerHTML]="pageData.plan.billRate"></p>
                              <!-- <i
                                #tooltip="matTooltip"
                                [matTooltip]="pageData.toolTipOpp"
                                matTooltipPosition="below"
                                matTooltipClass="gs-tooltip"
                                (click)="$event.preventDefault(); $event.stopImmediatePropagation(); tooltip.toggle()"
                                (keydown.enter)="tooltip.toggle()"
                                tabindex="0"
                                [attr.aria-label]="pageData.toolTipOpp"
                                role="tooltip"
                                class="gs-tooltip-icon fa-solid fa-circle-question"
                              ></i> -->
                            </div>
                          </div>
                        } @else {
                          <div class="one-side-details">
                            <p [innerHTML]="pageLabels.expirationText" class="detail-title"></p>
                            <p [innerHTML]="pageData.expirationDate" class="detail-value"></p>
                          </div>
                          <mat-divider class="divider"></mat-divider>
                          <div class="one-side-details">
                            <p [innerHTML]="pageLabels.planDetailsText" class="detail-title"></p>
                            <p class="detail-value" [innerHTML]="pageData.plan.billRate"></p>
                          </div>
                        }
                      } @else {
                        @if (pageData.plan.planType !== "Variable Rate") {
                          <div class="one-side-details">
                            <p [innerHTML]="pageLabels.planDetailsText" class="detail-title"></p>
                            <p class="detail-value" [innerHTML]="pageData.plan.billRate"></p>
                          </div>
                        }
                      }
                      <div class="current-plan-links-container">
                        @if (
                          accountDetail.CustomerClass !== "LRGCOM" &&
                          this.accountDetail.HeadlineCode !== "10" &&
                          this.accountDetail.LandLordAlertIndicator !== "Y"
                        ) {
                          <a
                            [attr.aria-label]="pageData.stopServiceAriaLabel"
                            class=""
                            [routerLink]="pageData.stopServiceURL"
                            >Stop Service</a
                          >
                          @if (showCtaButtons && this.accountDetail.EligibileForRenewal) {
                            <div class="renew-cta-tooltip-container">
                              <a
                                [attr.aria-label]="pageData.renewLinkAriaLabel"
                                role="link"
                                class="gs-link-btn mobile-align-text"
                                [class.disabled]="pageData.disableRenew"
                                [routerLink]="pageData.renewLinkURL"
                                [innerHTML]="pageData.renewLinkText"
                              ></a>
                            </div>
                          } @else if (this.accountDetail.EligibileForRateChange) {
                            <a
                              [attr.aria-label]="pageData.rateChangeAriaLabel"
                              role="link"
                              class="gs-link-btn mobile-align-text"
                              [routerLink]="pageData.rateChangeURL"
                              [innerHTML]="pageLabels.selectPlanLinkText"
                            ></a>
                          }
                        }
                        @if (accountDetail.ServiceAddressCount > 1) {
                          <a
                            [routerLink]="pageData.viewPlansURL"
                            [innerHTML]="pageData.viewPlansLabel"
                            [attr.aria-label]="pageData.viewPlansAriaLabel"
                          ></a>
                        }
                      </div>
                    </div>
                  </div>
                </mat-card-content>
              </mat-card>
            </div>
            @if (accountDetail.CustomerClass !== "LRGCOM" && accountDetail.LandLordAlertIndicator !== "Y") {
              <a
                [attr.aria-label]="pageData.startServiceAriaLabel"
                [routerLink]="pageData.startServiceURL"
                class="link-mat-cards"
              >
                <div class="new-service">
                  <mat-card class="new-service-card">
                    <mat-card-content class="new-service-card-content">
                      <div class="non-plan-container" [innerHTML]="pageLabels.startServiceCardHeadlineText"></div>
                    </mat-card-content>
                  </mat-card>
                </div>
              </a>
              <a
                [attr.aria-label]="pageData.moveServiceAriaLabel"
                [routerLink]="pageData.moveServiceURL"
                class="link-mat-cards"
              >
                <div class="transfer-service">
                  <mat-card class="current-plan-card">
                    <mat-card-content class="current-plan-card-content">
                      <div class="non-plan-container" [innerHTML]="pageLabels.transferServiceCardHeadlineText"></div>
                    </mat-card-content>
                  </mat-card>
                </div>
              </a>
            }
          </div>
          <app-side-panel [panelData]="sidePanelData"></app-side-panel>
        </div>
      </div>
    </div>
  </main>
}
